import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const providerIgnoredRequestsListColumns = [
  'providerIgnoredRequests.createdAt',
  'providerIgnoredRequests.reason',
  'providerIgnoredRequests.operation',
  'providerIgnoredRequests.playerId',
  'providerIgnoredRequests.roundId',
  'providerIgnoredRequests.betId',
  'providerIgnoredRequests.betAmount',
  'providerIgnoredRequests.providerId',
  'providerIgnoredRequests.startDate',
  'providerIgnoredRequests.endDate',
] as const;

export type ProviderIgnoredRequestsListColumns =
  (typeof providerIgnoredRequestsListColumns)[number];

export type ProviderIgnoredRequestsListFilter = {
  'providerIgnoredRequests.createdAt': string | undefined;
  'providerIgnoredRequests.reason': string | undefined;
  'providerIgnoredRequests.operation': string | undefined;
  'providerIgnoredRequests.playerId': string | undefined;
  'providerIgnoredRequests.roundId': string | undefined;
  'providerIgnoredRequests.betId': string | undefined;
  'providerIgnoredRequests.betAmount': string | undefined;
  'providerIgnoredRequests.providerId': string | undefined;
  'providerIgnoredRequests.startDate': string | undefined;
  'providerIgnoredRequests.endDate': string | undefined;
};

export const defaultProviderIgnoredRequestsListFilter: ProviderIgnoredRequestsListFilter = {
  'providerIgnoredRequests.createdAt': undefined,
  'providerIgnoredRequests.reason': undefined,
  'providerIgnoredRequests.operation': undefined,
  'providerIgnoredRequests.playerId': undefined,
  'providerIgnoredRequests.roundId': undefined,
  'providerIgnoredRequests.betId': undefined,
  'providerIgnoredRequests.betAmount': undefined,
  'providerIgnoredRequests.providerId': undefined,
  'providerIgnoredRequests.startDate': undefined,
  'providerIgnoredRequests.endDate': undefined,
};

export const providerIgnoredRequestsListColumnVisibilitySettings = {
  'providerIgnoredRequests.createdAt': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.reason': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.operation': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.playerId': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.roundId': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.betId': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.betAmount': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.providerId': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.startDate': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.endDate': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<ProviderIgnoredRequestsListColumns>;

export const defaultProviderIgnoredRequestsListColumnVisibility = defaultColumnVisibilityParams(
  providerIgnoredRequestsListColumnVisibilitySettings
);

export const providerIgnoredRequestsListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  providerIgnoredRequestsListColumns,
  providerIgnoredRequestsListColumnVisibilitySettings
);
